import React from 'react';
import IntakeStartScreen from 'components/common/intakeStartScreen';
import PharmacyMedicationsApp from 'components/pharmacyMedications';

function PharmacyMedicationsStart() {
  return (
    <IntakeStartScreen
      currentStep="pharmacy"
      metaTitle="Add Pharmacy, Allergies & Medications"
    >
      <PharmacyMedicationsApp />
    </IntakeStartScreen>
  );
}

export default PharmacyMedicationsStart;
